const FAVICON_SIZE = 64;
const BADGE_COLOR = "#d32f2f";

let faviconLoadCache = new Map();
let drawGeneration = 0;

function getFaviconLink() {
  return (
    document.querySelector("link[rel='icon']") ||
    document.getElementById("pwa-favicon")
  );
}

function formatBadgeLabel(count) {
  const n = Math.max(0, Number(count) || 0);
  if (n <= 0) return "";
  return n > 99 ? "99+" : String(n);
}

function loadFaviconImage(url) {
  if (!url) return Promise.reject(new Error("missing favicon url"));
  if (!faviconLoadCache.has(url)) {
    faviconLoadCache.set(
      url,
      new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("favicon load failed"));
        img.src = url;
      })
    );
  }
  return faviconLoadCache.get(url);
}

async function drawBadgedFavicon(count, faviconUrl) {
  const generation = ++drawGeneration;
  const label = formatBadgeLabel(count);
  if (!label) return;

  try {
    const img = await loadFaviconImage(faviconUrl);
    if (generation !== drawGeneration) return;

    const canvas = document.createElement("canvas");
    canvas.width = FAVICON_SIZE;
    canvas.height = FAVICON_SIZE;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.drawImage(img, 0, 0, FAVICON_SIZE, FAVICON_SIZE);

    const badgeRadius = FAVICON_SIZE * 0.22;
    const cx = FAVICON_SIZE - badgeRadius - 2;
    const cy = badgeRadius + 2;

    ctx.beginPath();
    ctx.arc(cx, cy, badgeRadius, 0, Math.PI * 2);
    ctx.fillStyle = BADGE_COLOR;
    ctx.fill();
    ctx.strokeStyle = "#ffffff";
    ctx.lineWidth = 2;
    ctx.stroke();

    ctx.fillStyle = "#ffffff";
    ctx.font = `bold ${label.length > 2 ? FAVICON_SIZE * 0.18 : FAVICON_SIZE * 0.26}px sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(label, cx, cy + 1);

    const link = getFaviconLink();
    if (link) link.href = canvas.toDataURL("image/png");
  } catch {
    /* mantém favicon original */
  }
}

function setNativeAppBadge(count) {
  if (typeof navigator === "undefined" || !("setAppBadge" in navigator)) return;
  const n = Math.max(0, Number(count) || 0);
  if (n <= 0) {
    navigator.clearAppBadge?.().catch(() => {});
    return;
  }
  navigator.setAppBadge(n).catch(() => {});
}

export function applyAppUnreadBadge(count, { baseTitle, faviconUrl } = {}) {
  const n = Math.max(0, Number(count) || 0);
  if (n <= 0) {
    clearAppUnreadBadge({ baseTitle, faviconUrl });
    return;
  }

  const label = formatBadgeLabel(n);
  if (baseTitle) {
    document.title = `(${label}) ${baseTitle}`;
  }
  setNativeAppBadge(n);
  if (faviconUrl) drawBadgedFavicon(n, faviconUrl);
}

export function clearAppUnreadBadge({ baseTitle, faviconUrl } = {}) {
  if (baseTitle) document.title = baseTitle;
  setNativeAppBadge(0);
  drawGeneration += 1;
  const link = getFaviconLink();
  if (link && faviconUrl) link.href = faviconUrl;
}
